import React, {useEffect,useState} from 'react'

const GoldSilverDropDown = (props) => {

    //runs on component mount and update
    useEffect(() => {
    }, [props.defaultGS])
    
    const options = ['Gold/Silver', 'Silver/Gold']
    var value = props.dafaultGS;

    const [oldValue, setOldValue] = useState(value);

    const fnChange = (e) => {
        setOldValue(e.target.value);
        props.handleChange(e.target.value, oldValue);
    }

    return(
            <select className='form-control gold-sliver-ratio' defaultValue={value}
            onChange={fnChange}>
                {options.map((item,key) => {
                    if(value === "item") 
                    return <option selected key={key}>{item}</option>
                    return <option key={key}>{item}</option>
                })}
            </select>
    )
}

export default GoldSilverDropDown;